import {
  Spinner,
  Button,
  Card,
  Separator,
  Input,
  Tooltip,
  Grid,
} from '@design-systems/canvas-ui'
import Icon, { InfoIcon } from '@design-systems/react-icons'

/**
 * Wrapper to any RFI Section
 * Purpose :
 * Show the header for the section, punchline (section description), add buttons which helps add a new row in the section
 * + It raises callback(setIsTriggerSave) in the event of movement out of the section - helps the parent to call autosave (with its own logic in parent)
 * @param {*} props
 * @returns
 */
export const SectionWrapper = (props) => {
  const sectionClassName = 'card-section hc8-ph-3x hc8-pt-6x hc8-pb-3x'
    .concat(props.isRfi3 ? ' border-all-grey-thin hc8-mh-3x' : ' hc8-mt-3x')
    .concat(
      props.errorCache?.section?.includes(props.sectionPath?.split('.')[1])
        ? ' border-section-error'
        : '',
    )

  return (
    <Card
      key={`card-section-${props.sectionTemplate?.order}`}
      data-testid="card-section-wrapper"
      className={sectionClassName}
      onMouseEnter={() => props.setIsTriggerSave(false)}
      onMouseLeave={() => props.setIsTriggerSave(true)}
    >
      {/* 1. Heading + Info icon */}
      <div className="row-centre">
        <Grid.Container align="center" spacing="none">
          <Grid.Item size={{ xs: 10 }} className="row-centre">
            <Input.Label className="hc8-fs-150 font-weight-500 hc8-mb-none">
              {props.sectionTemplate?.section_name}
            </Input.Label>
            {props.sectionTemplate?.info_icon && (
              <Tooltip
                className="hc8-ml-2x"
                content={props.sectionTemplate?.info_icon}
                location="right"
              >
                <Icon className="row-centre" svg={InfoIcon} />
              </Tooltip>
            )}
          </Grid.Item>
          <Grid.Item size={{ xs: 2 }} className="align-self-right hc8-pv-none">
            {props.addMoreMetadata?.isAddMore && (
              <div>
                <Button
                  data-testid="btn-add-more"
                  onClick={() => {
                    props.addMoreMetadata.addMore(
                      props.addMoreMetadata?.addMoreSubsectionReferenceKey,
                    )
                  }}
                  isDisabled={props.addMoreMetadata?.isDisabled}
                  variant="primary"
                  className="section-button"
                >
                  {props.addMoreMetadata?.isAddMoreInProgress ? (
                    <Spinner
                      size="sm"
                      longWaitAriaAlert="Adding another section"
                      data-testid="spinner-add-more-progress"
                    />
                  ) : (
                    props.addMoreMetadata?.addMoreButtonText
                  )}
                </Button>
              </div>
            )}
          </Grid.Item>
        </Grid.Container>
      </div>
      {/* 2. Section label */}
      {props.sectionTemplate?.section_label && (
        <Input.Label className="hc8-fs-150 hc8-mt-3x">
          <p
            className="text-style-section-label"
            dangerouslySetInnerHTML={{
              __html: [props.sectionTemplate.section_label],
            }}
          ></p>
        </Input.Label>
      )}
      <Separator className="hc8-mv-3x" />

      {/* 3. Section Body Content */}
      <div>{props.sectionBody}</div>
    </Card>
  )
}
